import React, { useRef, useState, useEffect } from "react";
import {
  Box,
  Button,
  FormControlLabel,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import Fileupload from "../FileuploadWithPreview/Fileupload";
import plus from "../../../src/assests/images/plus_red.svg";
import trash from "../../../src/assests/images/trash.svg";
import cancel from "../../../src/assests/images/close-circle.svg";
import galleryaddred from "../../../src/assests/images/galleryred.svg";
import galleryadd from "../../../src/assests/images/gallery-add.svg";
import { uploadimagetask } from "../../pages/create-task/api";
import { getToken } from "../../utils/utils";
import { useTaskContext } from "../store/AlltasksContext";

interface CheckboxItem {
  main_question_id: any;
  id: number;
  value: string;
  value_hi: string; // Added value_hi field
  checked: boolean;
  idid: number;
  smallimage: string;
  bigimage: string;
}

interface CheckboxProps {
  initialCheckBoxes: CheckboxItem[];
  placeholderPrefix: string;
  lang: {
    addOptions: string;
  };
  idid: number;
  token?: string;
  onCheckboxesChange?: (checkboxes: CheckboxItem[]) => void;
}

const Checkbox: React.FC<CheckboxProps> = ({
  initialCheckBoxes,
  placeholderPrefix,
  lang,
  idid,
  token,
  onCheckboxesChange,
}) => {
  const { checkboxItems, setCheckboxItems, setimagesdata, activeStep, step1data2defaultchekbox, setstep1data2defaultchekbox } =
    useTaskContext();
  const [imageMap, setImageMap] = useState<Record<number, string[]>>({});
  const [loadingBigImage, setLoadingBigImage] = useState<Record<number, boolean>>({});
  const [localImageMap, setLocalImageMap] = useState<Record<number, { smallimage: string; bigimage: string }>>({}); // New state for local blob URLs
  const tokenn = getToken();


  
  // Initialize Checkboxes
const Checkboxes = checkboxItems[idid] && checkboxItems[idid].length > 0
  ? checkboxItems[idid]
  : initialCheckBoxes.map(item => ({ ...item, value_hi: item.value_hi || "" }));


  // Pre-populate value_hi with value when switching to activeStep === 2
  useEffect(() => {
  if (activeStep === 2) {
    setCheckboxItems(prev => {
      const currentCheckboxes = prev[idid] || [];
      const updatedCheckboxes = currentCheckboxes.map(item => ({
        ...item,
        value_hi: item.value_hi || item.value, // preserve checked state
      }));
      return {
        ...prev,
        [idid]: updatedCheckboxes,
      };
    });
  }
}, [activeStep, idid, setCheckboxItems]);



console.log("kk0000000000000000")
  const addInstruction = () => {
    const newId =
      Checkboxes.length > 0
        ? Math.max(...Checkboxes.map((item) => item.id)) + 1
        : 1;

    const updatedCheckboxes = Checkboxes.map((item) => ({
      ...item,
      idid: idid,
    }));

    const newCheckboxes: CheckboxItem[] = [
      ...updatedCheckboxes,
      {
        main_question_id: updatedCheckboxes[0]?.main_question_id ?? null,
        id: newId,
        value: "",
        value_hi: "",
        checked: false,
        idid: idid,
        smallimage: "",
        bigimage: "",
      },
    ];

    setCheckboxItems((prev) => ({
      ...prev,
      [idid]: newCheckboxes,
    }));

    onCheckboxesChange?.(newCheckboxes);
  };

  const removeInstruction = (id: number) => {
    const newCheckboxes = Checkboxes.filter((item) => item.id !== id);

    setCheckboxItems((prev) => ({
      ...prev,
      [idid]: newCheckboxes,
    }));

    onCheckboxesChange?.(newCheckboxes);

    const updatedImageMap = { ...imageMap };
    delete updatedImageMap[id];
    setImageMap(updatedImageMap);

    const updatedLocalImageMap = { ...localImageMap };
    delete updatedLocalImageMap[id];
    setLocalImageMap(updatedLocalImageMap);

    setimagesdata((prev) =>
      prev.filter((item) => !(item.id === id && item.images.length > 0))
    );
  };

  const handleTextFieldChange = (id: number, newValue: string) => {
    const field = activeStep === 2 ? "value_hi" : "value";
    const newCheckboxes = Checkboxes.map((item) =>
      item.id === id ? { ...item, [field]: newValue } : item
    );

    setCheckboxItems((prev) => ({
      ...prev,
      [idid]: newCheckboxes,
    }));

    onCheckboxesChange?.(newCheckboxes);
  };

  const handleCheckChange = (id: number, isChecked: boolean) => {
    const newCheckboxes = Checkboxes.map((item) =>
      item.id === id ? { ...item, checked: isChecked } : item
    );

    setCheckboxItems((prev) => ({
      ...prev,
      [idid]: newCheckboxes,
    }));

    onCheckboxesChange?.(newCheckboxes);
  };

  const handleImageUpload = (id: number, files: FileList | null) => {
    if (files) {
      const newPreviews = Array.from(files).map((file) =>
        URL.createObjectURL(file)
      );

      setImageMap((prev) => ({
        ...prev,
        [id]: prev[id] ? [...prev[id], ...newPreviews] : newPreviews,
      }));

      setimagesdata((prev) => {
        const existingImages =
          prev.find((item) => item.id === id)?.images || [];
        return [
          ...prev.filter((item) => item.id !== id),
          { id, images: [...existingImages, ...newPreviews] },
        ];
      });
    }
  };

  const handleImageDelete = (id: number, index: number) => {
    setImageMap((prev) => {
      const updatedImages = prev[id]?.filter((_, i) => i !== index) || [];
      return { ...prev, [id]: updatedImages };
    });

    setimagesdata((prev) => {
      const updatedImages =
        prev.find((item) => item.id === id)?.images.filter((_, i) => i !== index) ||
        [];
      return [
        ...prev.filter((item) => item.id !== id),
        { id, images: updatedImages },
      ];
    });
  };

  const handleSmallImageUpload = async (id: number, file: File | null) => {
    if (!file) return;

    // Create local blob URL for UI rendering
    const localImageUrl = URL.createObjectURL(file);

    // Update localImageMap for rendering
    setLocalImageMap((prev) => ({
      ...prev,
      [id]: { ...prev[id], smallimage: localImageUrl },
    }));

    // Upload to API and get the response URL
    const formData = new FormData();
    formData.append("answer", file);
    try {
      const response = await uploadimagetask(formData, tokenn);
      const apiImageUrl = response.data.answer; // Assuming this is the URL from the API
      console.log(`Small image API response for ID ${id}:`, apiImageUrl);

      // Update Checkboxes with API URL
      const newCheckboxes = Checkboxes.map((item) =>
        item.id === id ? { ...item, smallimage: apiImageUrl } : item
      );

      setCheckboxItems((prev) => ({
        ...prev,
        [idid]: newCheckboxes,
      }));

      onCheckboxesChange?.(newCheckboxes);
    } catch (error) {
      console.error(`Failed to upload small image for ID ${id}:`, error);
    }
  };

  const handleBigImageUpload = async (id: number, file: File | null) => {
    if (!file) return;

    setLoadingBigImage((prev) => ({ ...prev, [id]: true }));

    // Create local blob URL for UI rendering
    const localImageUrl = URL.createObjectURL(file);

    // Update localImageMap for rendering
    setLocalImageMap((prev) => ({
      ...prev,
      [id]: { ...prev[id], bigimage: localImageUrl },
    }));

    // Upload to API and get the response URL
    const formData = new FormData();
    formData.append("answer", file);
    try {
      const response = await uploadimagetask(formData, tokenn);
      const apiImageUrl = response.data.answer; // Assuming this is the URL from the API
      console.log(`Big image API response for ID ${id}:`, apiImageUrl);

      // Update Checkboxes with API URL
      const newCheckboxes = Checkboxes.map((item) =>
        item.id === id ? { ...item, bigimage: apiImageUrl } : item
      );

      setCheckboxItems((prev) => ({
        ...prev,
        [idid]: newCheckboxes,
      }));

      onCheckboxesChange?.(newCheckboxes);
    } catch (error) {
      console.error(`Failed to upload big image for ID ${id}:`, error);
    } finally {
      setLoadingBigImage((prev) => ({ ...prev, [id]: false }));
    }
  };

  const handleSmallImageDelete = (id: number) => {
    const newCheckboxes = Checkboxes.map((item) =>
      item.id === id ? { ...item, smallimage: "" } : item
    );

    setCheckboxItems((prev) => ({
      ...prev,
      [idid]: newCheckboxes,
    }));

    setLocalImageMap((prev) => ({
      ...prev,
      [id]: { ...prev[id], smallimage: "" },
    }));

    onCheckboxesChange?.(newCheckboxes);
  };

  const handleBigImageDelete = (id: number) => {
    const newCheckboxes = Checkboxes.map((item) =>
      item.id === id ? { ...item, bigimage: "" } : item
    );

    setCheckboxItems((prev) => ({
      ...prev,
      [idid]: newCheckboxes,
    }));

    setLocalImageMap((prev) => ({
      ...prev,
      [id]: { ...prev[id], bigimage: "" },
    }));

    setLoadingBigImage((prev) => ({ ...prev, [id]: false }));

    onCheckboxesChange?.(newCheckboxes);
  };

  const clickedItem = useRef<number>(0);
  const cleckedItemHolder = useRef<number>(0);

 function handleSort() {
    const dragList = [...Checkboxes];
    const temp = dragList[clickedItem.current];
    dragList[clickedItem.current] = dragList[cleckedItemHolder.current];
    dragList[cleckedItemHolder.current] = temp;

    setCheckboxItems((prev) => ({
      ...prev,
      [idid]: dragList,
    }));

    onCheckboxesChange?.(dragList);
  }

  return (
    <Box sx={{ display: "flex", justifyContent: "end" }}>
      <Box sx={{ width: "100%", marginLeft: "50px" }}>
        {Checkboxes.map((instruction, index) => (
          <React.Fragment key={instruction.id}>
            <Box
              draggable
              onDragStart={() => (clickedItem.current = index)}
              onDragEnter={() => (cleckedItemHolder.current = index)}
              onDragEnd={handleSort}
              onDragOver={(e) => e.preventDefault()}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
                marginBottom: "22px",
              }}
            >
              <span
                style={{
                  cursor: "grabbing",
                  color: "#525252",
                  fontSize: "19px",
                }}
              >
                ⋮⋮
              </span>

              {/* Small Image Upload */}
              <Fileupload
                fileuploadclass="instruction-upload"
                iconSrc={galleryadd}
                onFileSelect={(file) =>
                  handleSmallImageUpload(instruction.id, file)
                }
                previewSize={{ width: 24, height: 24 }}
                onRemoveFile={() => handleSmallImageDelete(instruction.id)}
                previewImage={localImageMap[instruction.id]?.smallimage || instruction.smallimage} // Use local blob URL for rendering
              />

              {/* Checkbox + TextField */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  position: "relative",
                  width: "100%",
                }}
              >
                <FormControlLabel
                  sx={{
                    position: "absolute",
                    left: "0",
                    margin: "0",
                    zIndex: "1",
                    marginLeft: "10px",
                    input: { height: "20px", width: "20px" },
                  }}
                  control={
                    <input
                      type="checkbox"
                      checked={instruction.checked}
                      onChange={(e) =>
                        handleCheckChange(instruction.id, e.target.checked)
                      }
                    />
                  }
                  label=""
                />
                <TextField
                  sx={{
                    ".MuiInputBase-input": {
                      padding: "16px 16px 16px 44px",
                      color: "#171717",
                      fontSize: "16px",
                      fontWeight: "500",
                      background: "#F9FBFC",
                      borderRadius: "10px",
                      width: "100%",
                    },
                    ".MuiOutlinedInput-notchedOutline": {
                      borderColor: "transparent",
                    },
                  }}
                  placeholder={`${placeholderPrefix} ${instruction.id}${
                    activeStep === 2 ? " (Hindi)" : ""
                  }`}
                  variant="outlined"
                  value={
                    activeStep === 2
                      ? instruction.value_hi
                      : instruction.value
                  }
                  onChange={(e) =>
                    handleTextFieldChange(instruction.id, e.target.value)
                  }
                />
              </Box>

              {/* Big Image Upload */}
              <Tooltip title="Add Big Image" arrow>
                <Button
                  sx={{
                    backgroundColor: "transparent",
                    boxShadow: "none",
                    border: "1px solid #F1F2F3",
                    borderRadius: "10px",
                    padding: "16px",
                    "&:hover": { boxShadow: "none" },
                  }}
                  variant="contained"
                  component="label"
                >
                  <img src={galleryadd} alt="galleryadd" />
                  <input
                    type="file"
                    hidden
                    accept="image/*"
                    onChange={(e) =>
                      handleBigImageUpload(
                        instruction.id,
                        e.target.files ? e.target.files[0] : null
                      )
                    }
                  />
                </Button>
              </Tooltip>

              {/* Delete Instruction */}
              <Tooltip title="Delete" arrow>
                <Button
                  onClick={() => removeInstruction(instruction.id)}
                  sx={{
                    border: "1px solid #F1F2F3",
                    padding: "16px",
                    borderRadius: "10px",
                    minWidth: "56px",
                    height: "56px",
                    "&:hover": { backgroundColor: "transparent !important" },
                    ".MuiTouchRipple-root": { display: "none" },
                  }}
                >
                  <img
                    style={{ cursor: "pointer" }}
                    src={trash}
                    alt="trash"
                    height={24}
                    width={24}
                  />
                </Button>
              </Tooltip>
            </Box>

            {/* Render Gallery Images */}
            <Box
              className="showimages"
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: "8px",
                marginBottom: "22px",
              }}
            >
              {imageMap[instruction.id]?.map((preview, index) => (
                <Box
                  key={index}
                  sx={{
                    position: "relative",
                    display: "inline-block",
                    minHeight: "unset",
                  }}
                >
                  <img
                    src={preview}
                    alt={`Preview ${index}`}
                    style={{
                      width: "209px",
                      height: "209px",
                      margin: "5px",
                      border: "1px solid #E7E8E9",
                      borderRadius: "12px",
                      objectFit: "contain",
                    }}
                    onError={(e) => console.error(`Failed to load gallery image ${index} for ID ${instruction.id}: ${preview}`)}
                  />
                  <Button
                    onClick={() => handleImageDelete(instruction.id, index)}
                    sx={{
                      position: "absolute",
                      top: "-5px",
                      right: "-5px",
                      backgroundColor: "#FFF",
                      borderRadius: "6px",
                      boxShadow: "0px 4px 40px 0px rgba(0, 0, 0, 0.10)",
                      width: "24px",
                      height: "24px",
                      minWidth: "unset",
                      padding: "0",
                    }}
                  >
                    <img
                      src={cancel}
                      alt="Delete"
                      style={{ width: "16px", height: "16px" }}
                    />
                  </Button>
                </Box>
              ))}

              {/* Render Big Image */}
              {localImageMap[instruction.id]?.bigimage && !loadingBigImage[instruction.id] && (
                <Box sx={{ position: "relative" }}>
                  <img
                    src={localImageMap[instruction.id].bigimage} // Use local blob URL for rendering
                    alt="Big Image"
                    style={{
                      width: "209px",
                      height: "209px",
                      margin: "5px",
                      border: "1px solid #E7E8E9",
                      borderRadius: "12px",
                      objectFit: "contain",
                    }}
                    onError={(e) => console.error(`Failed to load big image for ID ${instruction.id}: ${localImageMap[instruction.id].bigimage}`)}
                  />
                  <Button
                    onClick={() => handleBigImageDelete(instruction.id)}
                    sx={{
                      position: "absolute",
                      top: "-5px",
                      right: "-5px",
                      backgroundColor: "#FFF",
                      borderRadius: "6px",
                      boxShadow: "0px 4px 40px 0px rgba(0, 0, 0, 0.10)",
                      width: "24px",
                      height: "24px",
                      minWidth: "unset",
                      padding: "0",
                    }}
                  >
                    <img
                      src={cancel}
                      alt="Delete"
                      style={{ width: "16px", height: "16px" }}
                    />
                  </Button>
                </Box>
              )}

              {/* Show loading state for big image */}
              {loadingBigImage[instruction.id] && (
                <Box
                  sx={{
                    width: "209px",
                    height: "209px",
                    margin: "5px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px dashed #C5C6C7",
                    borderRadius: "12px",
                  }}
                >
                  <Typography>Loading...</Typography>
                </Box>
              )}

              {/* Conditionally Render Add More Images Button */}
              {localImageMap[instruction.id]?.bigimage && !loadingBigImage[instruction.id] && (
                <Button
                  sx={{
                    boxShadow: "none !important",
                    borderRadius: "12px",
                    maxHeight: "214px",
                    border: "1px dashed var(--60, #C5C6C7)",
                    background: "var(--White, #FFF)",
                    textAlign: "center",
                    ".MuiButtonBase-root": { padding: "63px 41px" },
                  }}
                  variant="contained"
                  component="label"
                >
                  <Box>
                    <Box
                      sx={{
                        backgroundColor: "#FFEBEF",
                        borderRadius: "40px",
                        padding: "13px",
                        maxWidth: "54px",
                        maxHeight: "52px",
                        margin: "0 auto",
                      }}
                    >
                      <img
                        width={24}
                        height={24}
                        src={galleryaddred}
                        alt="Add More Images"
                      />
                    </Box>
                    <Typography
                      sx={{
                        color: "#696A6B",
                        fontSize: "16px",
                        fontWeight: "600",
                        textTransform: "none",
                        marginTop: "10px",
                      }}
                      variant="h6"
                    >
                      Add More Images
                    </Typography>
                  </Box>
                  <input
                    type="file"
                    hidden
                    multiple
                    accept="image/*"
                    onChange={(e) =>
                      handleImageUpload(instruction.id, e.target.files)
                    }
                  />
                </Button>
              )}
            </Box>
          </React.Fragment>
        ))}

        {/* Add new instruction */}
        <Button
          onClick={addInstruction}
          sx={{
            padding: "0",
            textTransform: "capitalize",
            fontSize: "14px",
            fontWeight: "500",
            color: "#C8172F",
          }}
        >
          <img style={{ marginRight: "8px" }} src={plus} alt="plus" />{" "}
          {lang.addOptions}
        </Button>
      </Box>
    </Box>
  );
};

export default Checkbox;